import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import TalentQuestionsContent from './TalentQuestionsContent'
export default class TalentQuestions extends Component {
    render() {
        let talent_id = this.props.match.params.id;
        let question_id = this.props.match.params.question_id;
        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <TalentQuestionsContent talent_id={talent_id} question_id={question_id} />
                <Footer />

            </div>


        )
    }
}
